
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75 14.25v9m0-1.5h15a3 3 0 0 0-3-3H9a3 3 0 0 0-3-3H.75m5.25 3h3m7.932-17.517 2.005 3.946h3.428a.884.884 0 0 1 .62 1.513L19.868 9.76l1.741 4a.883.883 0 0 1-1.243 1.122l-4.222-2.374-4.222 2.374a.883.883 0 0 1-1.243-1.122l1.742-4L9.3 6.692a.883.883 0 0 1 .62-1.513h3.428l2-3.946a.883.883 0 0 1 1.584 0Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    